// extracted by mini-css-extract-plugin
export var button = "_c3-4";
export var hasDarkBackground = "_c3-7";
export var hasLightBackground = "_c3-6";
export var iconWrapper = "_c3-0";
export var large = "_c3-2";
export var medium = "_c3-1";
export var small = "_c3-5";
export var xsmall = "_c3-3";